import Depreciations from 'components/assets/disable/AssetsDisableDepreciations';
import Form from 'components/assets/disable/AssetsDisableForm';
import EnableModal from 'components/assets/disable/AssetsDisableEnableModal';

export default { Depreciations, Form, EnableModal };



// WEBPACK FOOTER //
// src/components/assets/disable/index.js